module.exports = __webpack_public_path__ + "img/google-play-store.1fc23b4.svg";